export default "__VITE_ASSET__4d6150eb__"